"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = Tooltip;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var _CssClassNames = new _CssClassNames2["default"](_stylesModule["default"], ['utility', 'text']),
  className = _CssClassNames.className;
function TooltipContent(_ref) {
  var children = _ref.children,
    onInit = _ref.onInit,
    contentClassName = _ref.contentClassName;
  var innerRef = (0, _react.useRef)();
  var arrowRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (innerRef && innerRef.current && arrowRef && arrowRef.current) {
      onInit(innerRef.current.offsetWidth, innerRef.current.offsetHeight, arrowRef.current.offsetWidth, arrowRef.current.offsetHeight);
    }
  }, [innerRef, arrowRef, onInit]);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", _extends({
    ref: arrowRef
  }, className('arrow'))), /*#__PURE__*/_react["default"].createElement("div", _extends({
    ref: innerRef
  }, className("tooltip-inner ".concat(contentClassName ? contentClassName : ''))), typeof children === 'string' ? /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: children
    }
  }) : children));
}
function Tooltip(_ref2) {
  var children = _ref2.children,
    content = _ref2.content,
    _ref2$margin = _ref2.margin,
    margin = _ref2$margin === void 0 ? 0 : _ref2$margin,
    onOpen = _ref2.onOpen,
    onClose = _ref2.onClose,
    contentClassName = _ref2.contentClassName,
    forceShow = _ref2.forceShow;
  var childrenRefs = (0, _react.useRef)([]);
  (0, _react.useEffect)(function () {
    var mouseEnterListener = function mouseEnterListener(event) {
      var _node$parentNode, _node$parentNode2;
      var node = event.target;
      if (node.dataset.tooltipId || node !== null && node !== void 0 && (_node$parentNode = node.parentNode) !== null && _node$parentNode !== void 0 && (_node$parentNode = _node$parentNode.dataset) !== null && _node$parentNode !== void 0 && _node$parentNode.tooltipId || node !== null && node !== void 0 && (_node$parentNode2 = node.parentNode) !== null && _node$parentNode2 !== void 0 && (_node$parentNode2 = _node$parentNode2.parentNode) !== null && _node$parentNode2 !== void 0 && (_node$parentNode2 = _node$parentNode2.dataset) !== null && _node$parentNode2 !== void 0 && _node$parentNode2.tooltipId) {
        return;
      }
      var randomId = "tt".concat(Math.random().toString(36).substring(2, 15));
      node.dataset.tooltipId = randomId;
      var nodePosition = node.getBoundingClientRect();
      var item = window.document.createElement('div');
      item.setAttribute('id', randomId);
      item.setAttribute('role', 'tooltip');
      item.setAttribute('class', className('tooltip').className);
      var onItemEnter = function onItemEnter() {
        if (window["prevent".concat(randomId)]) {
          window["prevent".concat(randomId)]();
        }
        item.removeEventListener('mouseenter', onItemEnter);
      };
      item.addEventListener('mouseenter', onItemEnter);
      var onItemLeave = function onItemLeave() {
        if (window["close".concat(randomId)]) {
          window["close".concat(randomId)]();
        }
        item.removeEventListener('mouseleave', onItemLeave);
      };
      item.addEventListener('mouseleave', onItemLeave);
      window.document.body.appendChild(item);
      _reactDom["default"].render( /*#__PURE__*/(0, _react.createElement)(TooltipContent, {
        children: content,
        contentClassName: contentClassName,
        onInit: function onInit(width, height, arrowWidth, arrowHeight) {
          var position = 'bottom';
          var tooltipFromNodeLeft = (node.offsetWidth - width) / 2;
          var left = nodePosition.left + tooltipFromNodeLeft;
          var top = nodePosition.top + node.offsetHeight + margin;
          if (left < 10) {
            position = 'right';
            left = nodePosition.left + node.offsetWidth + margin;
            top = nodePosition.top + (node.offsetHeight - height) / 2;
          } else {
            var right = window.innerWidth - (node.offsetWidth + nodePosition.left - tooltipFromNodeLeft);
            if (right < 20) {
              position = 'left';
              left = nodePosition.left - width - arrowWidth - margin;
              top = nodePosition.top + (node.offsetHeight - height) / 2;
            }
          }
          if (position === 'bottom') {
            var bottomPointLimit = top + height + arrowWidth + margin + 10;
            if (bottomPointLimit > window.innerHeight) {
              position = 'top';
              top = nodePosition.top - height - arrowWidth - margin;
            }
          }
          item.style.left = "".concat(left + (window.pageXOffset || document.documentElement.scrollLeft), "px");
          item.style.top = "".concat(top + (window.pageYOffset || document.documentElement.scrollTop), "px");
          item.classList.add(className("bs-tooltip-".concat(position)).className);
          item.classList.add(className('show').className);
          if (onOpen) {
            onOpen();
          }
        }
      }), item);
      setTimeout(function () {
        node.addEventListener('click', mouseLeaveListener);
      }, 0);
    };
    var removeTooltip = function removeTooltip(randomId) {
      var tooltip = document.querySelector("#".concat(randomId));
      if (tooltip) {
        if (onClose) {
          onClose();
        }
        tooltip.remove();
      }
      var node = document.querySelector("[data-tooltip-id=\"".concat(randomId, "\"]"));
      if (node) {
        delete node.dataset.tooltipId;
        if (node.parentNode) {
          node.parentNode.focus();
        }
      }
    };
    var mouseLeaveListener = function mouseLeaveListener(event) {
      var node = event.target;
      var tooltipId = node.dataset.tooltipId;
      if (tooltipId) {
        var timeout = setTimeout(function () {
          removeTooltip(tooltipId);
        }, 100);
        window["prevent".concat(tooltipId)] = function () {
          window.clearTimeout(timeout);
        };
        window["close".concat(tooltipId)] = function () {
          removeTooltip(tooltipId);
        };
        node.removeEventListener('click', mouseLeaveListener);
      }
    };
    childrenRefs.current.forEach(function (node) {
      if (typeof forceShow === 'undefined') {
        node.addEventListener('mouseenter', mouseEnterListener);
        node.addEventListener('click', mouseEnterListener);
        node.addEventListener('mouseleave', mouseLeaveListener);
      } else if (forceShow) {
        mouseEnterListener({
          target: node
        });
      } else {
        mouseLeaveListener({
          target: node
        });
      }
    });
    return function () {
      childrenRefs.current.forEach(function (node) {
        node.removeEventListener('mouseenter', mouseEnterListener);
        node.removeEventListener('mouseleave', mouseLeaveListener);
        node.removeEventListener('click', mouseEnterListener);
      });
    };
  }, [childrenRefs, margin, onOpen, onClose, contentClassName, content, forceShow]);
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, _react.Children.map(children, function (element, i) {
    if (typeof element === 'string') {
      return /*#__PURE__*/_react["default"].createElement("span", {
        ref: function ref(_ref3) {
          return childrenRefs.current[i] = _ref3;
        }
      }, element);
    }
    return /*#__PURE__*/(0, _react.cloneElement)(element, {
      ref: function ref(_ref4) {
        return childrenRefs.current[i] = _ref4;
      }
    });
  }));
}